import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=fc61d174&"
import script from "./UserLogs.vue?vue&type=script&lang=js&"
export * from "./UserLogs.vue?vue&type=script&lang=js&"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=fc61d174&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports